import script from "./RegistroPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistroPage.vue?vue&type=script&setup=true&lang=ts"

import "./RegistroPage.vue?vue&type=style&index=0&id=38525af4&lang=css"

const __exports__ = script;

export default __exports__